/* eslint-disable */
export default {
  searchPlaceholder: '검색...',
  refresh: '새로 고침',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
